import { Collapse, CollapsePanelProps, Space, Typography } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import {
  AnswerTextCollection,
  JobPostingDetail,
  QuestionAlternativeCollection,
  QuestionCollection,
} from '../../types';
import CandidateAnswerAlternatives from './CandidateAnswerAlternatives';
import CandidateAnswerTextCard from './CandidateAnswerTextCard';

interface CandidateAnsweredQuestionnaireProps extends Omit<CollapsePanelProps, 'header'> {
  jobPostingName?: JobPostingDetail['name'];
  questions?: QuestionCollection[];
  textQuestionsAnswers?: Record<QuestionCollection['id'], AnswerTextCollection>;
  answerAlternatives?: QuestionAlternativeCollection['id'][];
}

const CandidateAnsweredQuestionnairePanel = ({
  jobPostingName,
  questions,
  textQuestionsAnswers,
  answerAlternatives,
  ...props
}: CandidateAnsweredQuestionnaireProps) => {
  return (
    <Collapse.Panel
      {...props}
      header={
        <Typography.Title level={4}>
          <Trans>Perguntas de pré-requisito da vaga</Trans> {jobPostingName || ''}
        </Typography.Title>
      }
    >
      <Space direction="vertical" size="middle">
        {questions?.map((question) => {
          return (
            <React.Fragment key={question.id}>
              <Typography.Text style={{ fontSize: 17 }}>{question.description}</Typography.Text>
              {question.type === 'TEXT' && (
                <CandidateAnswerTextCard
                  answerText={
                    textQuestionsAnswers ? textQuestionsAnswers[question.id]?.text || undefined : ''
                  }
                />
              )}
              {(question.type === 'RADIO' || question.type === 'CHECKBOX') && (
                <CandidateAnswerAlternatives
                  questionType={question.type}
                  questionAlternatives={question.alternatives}
                  answerAlternatives={answerAlternatives}
                />
              )}
            </React.Fragment>
          );
        })}
      </Space>
    </Collapse.Panel>
  );
};

export default CandidateAnsweredQuestionnairePanel;
